var Vendd = (function (Vendd) {
	'use strict';

	Vendd.MessageBus = (function (MessageBus) {
		var messages = {};

		MessageBus.messages = messages;

		MessageBus.VenddMessage = function (className, data) {
		    this.className = className;
		    this.data = data;
		};

	    MessageBus.Envelope = function(sender, message, isAsync) {
	        this.sender = sender;
	        this.message = message;
	        this.isAsync = isAsync;
	    };

		function checkMessage(message) {
		    if (!message.className) {
				throw 'Message must have a className';
			}
		};

	 	function checkMessageFunction(func) {
			if (typeof (func) != 'function') {
				throw 'Func must be a function. Func :' + typeof (func);
			}
		};

		function locateObserver(observers, observer) {
			for(var i = 0; i < observers.length; i++) {
				if (observers[i].Observer === observer) {
					return i;
				}
			}

			return -1;
		};

        function sendMessage(func, envelope) {
            func(envelope);
        };

        function postMessage(func, envelope) {
			setTimeout(function () { func(envelope); }, 0);
        };

		MessageBus.subscribe = function (messageType, observer, func) {
		    checkMessage(messageType);
		    checkMessageFunction(func);

		    var observers = messages[messageType.className];
			if (!Array.isArray(observers)) {
				observers = [];
				messages[messageType.className] = observers;
			}

			var msg = {
				Observer:observer,
				Func:func
			};

			var pos = locateObserver(observers, observer);

			if (pos != -1) {
				observers[pos] = msg;
			} else {
				observers.push(msg);
			}
		};

	    MessageBus.unsubscribe = function(messageType, observer) {
	        checkMessage(messageType);

	        var observers = messages[messageType.className];
	        if (!Array.isArray(observers))
	            return;

	        var pos = locateObserver(observers, observer);
	        if (pos != -1) {
	            observers.splice(pos, 1);
	        }
	    };

		MessageBus.unsubscribeAll = function (messageType) {
		    checkMessage(messageType);

			if (Array.isArray(messages[messageType.className])) {

			    delete messages[messageType.className];
			}
		};

		MessageBus.publish = function (sender, message) {
			checkMessage(message);

			var observers = messages[message.className];
			if (Array.isArray(observers)) {
                for (var i = 0; i < observers.length; i++) {
                    var envelope = new MessageBus.Envelope(sender, message, false);
			        sendMessage(observers[i].Func, envelope);
				}
			}
		};

		var asyncMessageQueue = [];

		function processMessages() {
		    var localqueue = asyncMessageQueue.slice();
		    asyncMessageQueue = []; 

		    for (var i = 0; i < localqueue.length; i++) {
                var message = localqueue[i].message;               
		        var sender = localqueue[i].sender;
		        var observers = messages[message.className];
                if (Array.isArray(observers)) { 
                    var envelope = new MessageBus.Envelope(sender, message, true);
                    for (var j = 0; j < observers.length; j++) {
                        postMessage(observers[j].Func, envelope);
		            }
		        }
		    }
		};

		MessageBus.publishAsync = function (sender, message) {
		    checkMessage(message);
		    asyncMessageQueue.push({
		        sender: sender,
		        message: message
		    });

			setTimeout(function () { processMessages(); }, 0);
		};

		return MessageBus;

	})(Vendd.MessageBus || {});

	return Vendd;

 })(Vendd || {});